import gql from "graphql-tag";

// eslint-disable-next-line import/no-default-export
export default gql`
	mutation onChangeMeta($input: OnChangeMetaInput!) {
		onChangeMeta(input: $input) {
			onChangeMeta {
				metaData {
					documentId,
					id
					key
					value
					timeStamp
					valueType
					selected
					confidence
					source
				}
				validations {
					id
					timeStamp
					userIdentifier
					validator
					severity
					severity
					field
					message
				}
				audits {
					id
					timeStamp
					userIdentifier
					source
					severity
					type
					message
				}
				updated
			}
		}
	}
`;
